
<div class="input-wrapper">
    <button type="button" class="decrement" (click)="decrement()" [disabled]="disabled" aria-label="Decrement">-</button>
    <input
            [value]="rawInput"
            (input)="onInput($event)"
            (blur)="onBlur()"
            [disabled]="disabled"
            [attr.min]="min"
            [attr.max]="max"
            [attr.step]="step"
            [ngStyle]="{'width': width + 'px'}"
            type="text"
            autocomplete="off",
            inputmode="decimal"
    />
    <button type="button" class="increment" (click)="increment()" [disabled]="disabled" aria-label="Increment">+</button>
</div>
